export const tippyAttrs = {
   interactive: true,
   placement: 'auto',
   maxWidth: '80vw',
   allowHTML: true,
   theme: 'light',
   hideOnClick: false,
   // trigger: 'click'
}